<template>
    <div class="content-area">
        <div class="content-caption dashed">
            <span>退款详情</span>
        </div>
        <div class="form-single">
            <div class="title">退款单据号</div>
            <div class="content">
                <span>{{refundVoucher.no}}</span>
            </div>
        </div>
        <div class="form-single" v-if="refundVoucher.settleProofId != -1">
            <div class="title">结算单号</div>
            <div class="content">
                <span>{{refundVoucher.settleProofNo}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">退款状态</div>
            <div class="content">
                <span> {{refundVoucher.refundResultText}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">发票</div>
            <div class="content">
                <span>{{refundVoucher.invoiceTypeText}}</span>
            </div>
        </div>
        <hr/>
        <div class="form-single">
            <div class="title">收款方</div>
            <div class="content">
                <span>{{refundVoucher.buyerName}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">收款方式</div>
            <div class="content">
                <span>{{refundVoucher.payWayText}}</span>
            </div>
        </div>
        <!--<div class="form-single" style="overflow: visible;">
            <div class="title">收款账号</div>
            <div class="content">
                {{refundVoucher.sellerAcctNo}}
                12121212
            </div>
        </div>
        <div class="form-single" style="overflow: visible;">
            <div class="title">电话</div>
            <div class="content">
                {{111111}}
            </div>
        </div>
        <div class="form-single" style="overflow: visible;">
            <div class="title">邮箱</div>
            <div class="content">
                {{111111}}
            </div>
        </div>
        <div class="form-single" style="overflow: visible;">
            <div class="title">款项说明</div>
            <div class="content">
                {{111111}}
            </div>
        </div>-->
        <hr/>
        <div class="form-single">
            <div class="title">退款金额</div>
            <div class="content">
                <span class="font-red font16"><b>{{(parseFloat(refundVoucher.amount)).toFixed(2)}}</b> 元</span>
            </div>
        </div>
        <div class="form-single" v-if="optionFlag != 'shenHe'">
            <div class="title">留言</div>
            <div class="content" v-if="optionFlag == 'fuKuan'">
                <textarea v-model="refundVoucher.memo" style="width: 320px;height: 90px"></textarea>
            </div>
            <div class="content" v-if="optionFlag == 'chaKan'">
                <span>{{refundVoucher.memo}}</span>
            </div>
        </div>
        <div v-if="optionFlag != 'shenHe'">
            <div class="form-single">
                <div class="title">审核结果</div>
                <div class="content">
                    <span>{{refundVoucher.auditStateText}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">审核描述</div>
                <div class="content">
                    <span> {{refundVoucher.auditDesc}}</span>
                </div>
            </div>
        </div>
        <div v-if="optionFlag == 'shenHe'">
            <div class="form-single">
                <div class="title">审核结果</div>
                <div class="content">
                    <el-radio-group v-model="refundVoucher.auditState">
                        <el-radio v-for="auditStateInfo in auditStateList" :label="auditStateInfo.value">
                            <span>{{auditStateInfo.text }}</span>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-single">
                <div class="title">审核描述</div>
                <div class="content">
                    <textarea v-model="refundVoucher.auditDesc" style="width: 320px;height: 90px"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import finacApi from '../../api/finac'

    export default{
        name: 'swb-refund-voucher-detail',
        desc: '退款详情',
        props: ['voucherId', 'optionFlag'],
        data: function () {
            return {
                refundVoucher: {
                    auditState: getEnumInfoWith('auditState', 'name', 'AuditPass').value,
                },
                auditStateList: []
            }
        },
        created: function () {
            //
            this.auditStateList = getEnumInfoWith('auditState', 'name', ['AuditFail', 'AuditPass']);
            //
            this.getPayVoucherInfo();
        },
        methods: {
            getPayVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getRcvVoucherCOById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let refundVoucher = result.data;
                        //
                        let payWayInfo = getEnumInfoWith('payWay', 'value', refundVoucher.payWay);
                        if(payWayInfo != null) {
                            refundVoucher.payWayText = payWayInfo.text;
                        }
                        //
                        let auditStatefo = getEnumInfoWith('auditState', 'value', refundVoucher.auditState);
                        if(!Utils.isNoB(auditStatefo)) {
                            refundVoucher.auditStateText = auditStatefo.text;
                        }
                        //
                        let resultStateInfo = getEnumInfoWith('resultState', 'value', refundVoucher.payResult);
                        if(resultStateInfo != null) {
                            if(resultStateInfo.name == "Failure") {
                                refundVoucher.refundResultText = "退款失败";
                            } else if(resultStateInfo.name == "Success") {
                                refundVoucher.refundResultText = "退款成功";
                            } else {
                                if(!Utils.isNoB(auditStatefo) && auditStatefo.name == 'AuditFail') {
                                    refundVoucher.refundResultText = "拒绝退款";
                                } else {
                                    refundVoucher.refundResultText = "待退款";
                                }
                            }
                        }
                        //
                        let invoiceTypeInfo = getEnumInfoWith('invoiceType', 'value', refundVoucher.invoiceType);
                        if(invoiceTypeInfo != null) {
                            refundVoucher.invoiceTypeText = invoiceTypeInfo.text;
                        }
                        //
                        self.refundVoucher = refundVoucher;
                        self.refundVoucher.auditState = getEnumInfoWith('auditState', 'name', 'AuditPass').value;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let result = {};
                result.data = this.refundVoucher;
                result.type = "info";
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/RefundVoucherDetail.vue